<div class="credit-card-wrap">
<div class="mk-icon-world-map"></div>
	<div class="credit-card-inner">
	  <div class="credit-font">
	    <p>This identity card is not transferable. It must be produced at any time if requested by any officer of the company or authorised person(s)</p>
	  </div>
	</div>
</div>